import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../Services/loader.service';
import { environment } from '../../../../environments/environment';

const SKIP_LOADING_HEADER = 'skip-loading';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoaderService);
  const skipLoading = req.headers.get(SKIP_LOADING_HEADER) === 'true';
  const active = environment.loaderOnHttp && !skipLoading;

  if (active) {
    loader.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (active) {
        loader.hide();
      }
    })
  );
};
